<template>
  <div class="container">
    <EnterpriseSearchWindow @search="search"/>
    <EnterpriseSearchResult :enterpriseList="enterpriseList" :isExistSearchResult="isExistSearchResult"/>
  </div>
</template>

<script>
import EnterpriseSearchWindow from '@/components/pages/EnterpriseSearchWindow'
import EnterpriseSearchResult from '@/components/pages/EnterpriseSearchResult'

export default {
  name: 'enterprise-list',

  props: {
    message: null
  },

  data () {
    return {
      screenTitle: '[マスタ設定] 企業情報一覧',
      enterpriseList: [],
      isExistSearchResult: false
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  async created () {
    this.$emit('setMessage', this.message, false)
    // 企業情報操作（一括取得）API
    await this.axios.get('/api/enterprise/getall', {
      headers: {
        'Authorization': this.$session.get('accessToken'),
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
      }
    }).then((response) => {
      this.enterpriseList = response.data
      if (this.enterpriseList.length > 0) {
        this.isExistSearchResult = true
      } else {
        this.isExistSearchResult = false
      }
    })
  },

  methods: {
    async search (enterpriseCode, createDateFrom, createDateTo) {
      this.$emit('setMessage', null, false)
      var params = {
        enterpriseCode: enterpriseCode,
        enterpriseCreateDateFrom: createDateFrom,
        enterpriseCreateDateTo: createDateTo
      }
      // 企業情報操作（取得）API
      await this.axios.get('/api/enterprise/get', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        this.enterpriseList = response.data
        if (this.enterpriseList.length > 0) {
          this.isExistSearchResult = true
        } else {
          this.isExistSearchResult = false
        }
      })
    }
  },

  components: {
    EnterpriseSearchWindow,
    EnterpriseSearchResult
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/EnterpriseList.vue